// Styles
import "./socket-status.scss";
import { useSelector } from "react-redux";
import { RootState } from "../../../../../../shared/store/store";

export const SocketStatus = () => {
	const socketStatus = useSelector(
		(state: RootState) => state.app.socketStatus,
	);
	const statuses = {
		online: "Онлайн",
		connecting: "Підключення",
		"offline-reconnect": "Відключено (перепідключення)",
		"connection-error": "Помилка з'єднання",
		"auth-error": "Помилка авторизації",
	};
	return (
		<div className='socket-status'>
			<div className={`socket-status__marker ${socketStatus}`}></div>
			<div className='socket-status__label'>{statuses[socketStatus]}</div>
		</div>
	);
};
